<template>
  <div class="form-group">
    <label :for="id" class="form-label" v-safe-html="label"></label>
    <select 
      :id="id" 
      v-model="internalValue" 
      class="form-control"
      :multiple="multiple"
      :style="multiple ? { height: '100px' } : {}"
    >
      <option
        v-for="opt in options"
        :key="opt.value"
        :value="opt.value"
        :disabled="opt.disabled === true || (optionDisabled && optionDisabled(opt.value))"
      >
        {{ opt.text }}
      </option>
    </select>
    <div v-if="error" class="invalid-feedback">{{ error }}</div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [String, Number, Array],
      default: () => [],
    },
    label: { type: String, required: true },
    id: { type: String, required: true },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    mask: { type: String, default: null },
    className: { type: String, default: '' },
    error: { type: String, default: '' },
    multiple: { type: Boolean, default: false },
    optionDisabled: { type: Function, default: null }, // (value:number|string) => boolean

  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    formattedValue() {
      if (!this.mask || !this.modelValue) return this.modelValue;
      return this.applyMask(this.modelValue, this.mask);
    },
  },
  methods: {
    applyMask(value, mask) {
      const masks = {
        cpf: v =>
          v.replace(/\D/g, '')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2'),
        telefone: v =>
          v.replace(/\D/g, '')
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{4})(\d)/, '$1-$2'),
        celular: v =>
          v.replace(/\D/g, '')
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{5})(\d)/, '$1-$2'),
        cep: v =>
          v.replace(/\D/g, '')
            .replace(/(\d{5})(\d{1,3})$/, '$1-$2'),
      };
      return masks[mask] ? masks[mask](value) : value;
    },
  },
};
</script>

<style>
.form-group {
  margin-bottom: 0.5rem;
}
.invalid-feedback {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 0.25rem;
}
.form-control {
  padding: 0.25rem 0.5rem;
  font-size: 0.73rem;
  /* A altura padrão pode ser definida aqui para seleção única */
  height: 25px;
  border-radius: 4px;
  box-sizing: border-box;
}
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
  margin-top: 0.5rem;
}
label {
  font-size: 0.73rem;
  margin-bottom: 0.2rem;
  display: block;
}
</style>
